import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Suppress console.log in production for cleaner output and security
// Keep console.error and console.warn for debugging production issues
if (import.meta.env.PROD) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  // Keep these for production debugging:
  // console.error
  // console.warn
}

createRoot(document.getElementById("root")!).render(<App />);
